// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"Spinner_spinnerContainer__Pi0JY","spinner":"Spinner_spinner__KOr6i"};